import { isRichContentEqual } from 'ricos-content/libs/is-rich-content-equal';
export const isCommentContentEqual = (content1, content2) => {
    if (!content1 || !content2) {
        return false;
    }
    return isRichContentEqual(content1, content2);
};
export function assertServerRichContent(content) {
    if (content && typeof content === 'object' && 'nodes' in content) {
        return;
    }
    throw new Error(`Is not a RichContent object ${JSON.stringify(content)}`);
}
export function assertServiceRichContent(content) {
    if (content && typeof content === 'object' && 'nodes' in content) {
        return;
    }
    throw new Error(`Is not a RichContent object ${JSON.stringify(content)}`);
}
//# sourceMappingURL=content-utils.js.map